import React, { useEffect, useState } from "react";
import ManageAccountTab from "../../ManageAccountTab";
import { useSelector } from "react-redux";
import BusinessProtectionPlanDialogContainer from "./BusinessProtectionPlanDialogContainer";
import NoActivePlan from "../NoActivePlan";
import BusinessProtectionPlanRow from "./BusinessProtectionPlanRow";
import { ApplicationState } from "../../../../store";
import ErrorBoundary from "../../../common/ErrorBoundary";
import { IPackage, IProduct, ISmbLicenseLimit } from "../../../../store/protectionPlanService/business/types";
import { Notification } from "../../../common/Notification";
import { useTranslation } from "react-i18next";
import * as services from "../../../../store/service";
import * as httpClient from "../../../../util/httpClient";

const BusinessProtectionPlan: React.FunctionComponent = () => {
    const [packages, setPackages] = useState<IPackage[]>();
    const [isChangingLicense, setIsChangingLicense] = useState(false);
    const [isFirstPlan, setIsFirstPlan] = useState(true);
    const [confirmationDialog, setConfirmationDialog] = useState(false);
    const [initialDialog, setInitialDialog] = useState("");
    const [packageIndex, setPackageIndex] = useState(-1);
    const [licenseLimit, setLicenseLimit] = useState("");
    const [subscriptionTypeChange, setSubscriptionTypeChange] = useState(false);
    const [keepPackage, setKeepPackage] = useState(false);
    const isAvastId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2611
                ? true
                : false
            : false
    );

    const protectionPlanSelector = useSelector((state: ApplicationState) => {
        return state.protectionPlanBusinessState;
    });
    const licenseLimitSelector = useSelector((state: ApplicationState) => {
        return state.protectionPlanBusinessState?.protectionPlanData?.LicenseLimit;
    });
    const activePendingLicense = useSelector((state: ApplicationState) => {
        return state.protectionPlanBusinessState?.protectionPlanData?.ActiveAndPendingLicenseLimit || "";
    });

    const partnerPhoneNumber: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : ""
    );
    const { t: tLang } = useTranslation();

    const [isTwoStepCancellation, setTwoStepCancellation] = useState(false);

    const getTwoStepCancellationStates = () => {
        httpClient.sendRequest("GET", "api/accountInfo/getAccountInformation").then((accountInfodata) => {
            if (accountInfodata && accountInfodata.hasError === false) {
                const requestBody = {
                    TransactionType: "TWO-STEP-CANCEL",
                    PartnerID: null,
                    RetailerID: null,
                    CountryISO: accountInfodata._unifiedAccountInfo.country,
                    IsDisabled: false
                };
                services
                    .getTwoStepCancellationStates(requestBody)
                    .then((data) => {
                        if (!data["hasError"]) {
                            let isTwoStepCancellationState = data.twoStepCancellationStatesList.some((el: { stateCode: string | undefined; }) => el.stateCode === accountInfodata._unifiedAccountInfo.state)
                            if (isTwoStepCancellationState) {
                                setTwoStepCancellation(true);
                            }
                        }
                    }).catch((err) => {
                        Notification({
                            type: "error",
                            title: tLang("manageAccount.protectionPlan.notification.errorTitle"),
                            message: tLang("manageAccount.protectionPlan.notification.somethingWentWrongMsg"),
                        });
                    });

            }
        }).catch((err) => {
            Notification({
                type: "error",
                title: tLang("manageAccount.protectionPlan.notification.errorTitle"),
                message: tLang("manageAccount.protectionPlan.notification.somethingWentWrongMsg"),
            });
        });
    };

    useEffect(() => {
        getTwoStepCancellationStates(); 
    }, []);

    useEffect(() => {
        if (isAvastId) {
            document.title = tLang("manageAccount.protectionPlan.documentTitle");
        }
    }, []);

    useEffect(() => {
        if (licenseLimitSelector) {
            preparePackages(licenseLimitSelector);
        }
    }, [licenseLimitSelector]);

    const confirmChange = (index: number, initDialog: string) => {
        setPackageIndex(index);
        setInitialDialog(initDialog);
        setConfirmationDialog(true);
    };

    const confirmChangeSubscription = (index: number, initDialog: string) => {
        setSubscriptionTypeChange(true);
        confirmChange(index, initDialog);
    };

    const closeProtectionPlanDialog = () => {
        setPackageIndex(-1);
        setInitialDialog("");
        setSubscriptionTypeChange(false);
        setConfirmationDialog(false);
    };

    const isDisplayNoActivePkgMsg = () => {
        if (protectionPlanSelector && protectionPlanSelector.protectionPlanData) {
            const packages = protectionPlanSelector.protectionPlanData.packageList;
            const activePackage = packages?.find((it) => it.IsActive);
            if (packages && packages.length > 0 && !activePackage) {
                return true;
            }
        }
        return false;
    };

    const showNextPlan = () => {
        var protectionPlanTable: any = document.getElementById("protection-table");
        if (protectionPlanTable != null) {
            var currentPlan = 0;
            let currentPlanText = protectionPlanTable.getAttribute("class") + "";
            currentPlan = parseInt(currentPlanText.substr(currentPlanText.length - 1));
            var tablePlans = protectionPlanTable.rows[0].cells.length;
            tablePlans = tablePlans - 1;

            if (tablePlans === currentPlan) {
                (document.getElementById("btn-next-plan") as HTMLButtonElement)!.disabled = true;
            } else {
                protectionPlanTable.classList.remove("show-plan-" + currentPlan);
                currentPlan++;
                protectionPlanTable.classList.add("show-plan-" + currentPlan);

                if (tablePlans === currentPlan) {
                    (document.getElementById("btn-next-plan") as HTMLButtonElement)!.disabled = true;
                    (document.getElementById("btn-prev-plan") as HTMLButtonElement)!.disabled = false;
                } else {
                    (document.getElementById("btn-next-plan") as HTMLButtonElement)!.disabled = false;
                    (document.getElementById("btn-prev-plan") as HTMLButtonElement)!.disabled = false;
                }
            }
            setIsFirstPlan(false);
        }
    };

    const showPrevPlan = () => {
        let protectionPlanTable: any = document.getElementById("protection-table");
        if (protectionPlanTable != null) {
            var currentPlan = 0;
            let currentPlanText = protectionPlanTable.getAttribute("class") + "";
            currentPlan = parseInt(currentPlanText.substr(currentPlanText.length - 1));
            var tablePlans = protectionPlanTable.rows[0].cells.length;
            tablePlans = tablePlans - 1;

            if (currentPlan === 1) {
                (document.getElementById("btn-prev-plan") as HTMLButtonElement)!.disabled = true;
            } else {
                protectionPlanTable.classList.remove("show-plan-" + currentPlan);
                currentPlan--;
                protectionPlanTable.classList.add("show-plan-" + currentPlan);

                if (currentPlan === 1) {
                    (document.getElementById("btn-next-plan") as HTMLButtonElement)!.disabled = false;
                    (document.getElementById("btn-prev-plan") as HTMLButtonElement)!.disabled = true;
                } else {
                    (document.getElementById("btn-next-plan") as HTMLButtonElement)!.disabled = false;
                    (document.getElementById("btn-prev-plan") as HTMLButtonElement)!.disabled = false;
                }
            }
        }
    };

    const showRow = (section: string) => {
        let billingArr = [];
        let savingsArr = [];
        let providedArr = [];
        let showPrice = false;
        let showButton = false;
        let showPlanLicense = true;

        if (packages) {
            packages.map((pkg) => {
                showPrice = true;
                if (pkg.BillingText) {
                    billingArr.push(pkg.BillingText);
                }
                if (
                    (pkg.IsActive && (pkg.IsPackageCancel || pkg.PartnerId === 428)) ||
                    (!pkg.IsActive && (pkg.IsPacakgeUpgradable || (pkg.Price != null && pkg.Price === 0 && pkg.IsPSS)))
                ) {
                    showButton = true;
                }
                if (pkg.ShowSubscriptionTypeChangeText) {
                    savingsArr.push(pkg.ShowSubscriptionTypeChangeText);
                }
                if (pkg.PartnerName) {
                    providedArr.push(pkg.PartnerName);
                }
            });
        }

        switch (section) {
            case "price":
                if (showPrice) {
                    return true;
                }
                break;
            case "cta":
                if (showButton) {
                    return true;
                }
                break;
            case "billing":
                if (billingArr.length > 0) {
                    return true;
                }
                break;
            case "plan-licenses":
                if (showPlanLicense) {
                    return true;
                }
                break;
            case "savings":
                if (savingsArr.length > 0) {
                    return true;
                }
                break;
            case "providedBy":
                if (providedArr.length > 0) {
                    return true;
                }
                break;
            default:
                return false;
        }
    };

    const renderSpacer = () => {
        return (
            <th className="row-label" scope="col">
                <div className="sr-only">{tLang("manageAccount.protectionPlan.feature")}</div>
            </th>
        );
    };

    const renderPackageHeaderRow = (section: string) => {
        return (
            <React.Fragment>
                {packages?.map((pkg, pkgIndex: number) => (
                    <th className="row-cell" scope="col" key={"pkg-detail-" + pkgIndex}>
                        <div className="plan-container">
                            {section === "title" ? (
                                renderTitle(pkg)
                            ) : section === "price" ? (
                                renderPrice(pkg)
                            ) : section === "cta" ? (
                                renderButton(pkg, pkgIndex)
                            ) : section === "plan-licenses" ? (
                                renderPlanLicenses(pkg)
                            ) : section === "billing" ? (
                                renderBilling(pkg)
                            ) : section === "savings" ? (
                                renderSavings(pkg, pkgIndex)
                            ) : section === "providedBy" ? (
                                renderProvidedBy(pkg)
                            ) : (
                                <></>
                            )}
                        </div>
                    </th>
                ))}
            </React.Fragment>
        );
    };

    const renderTitle = (pkg: IPackage) => {
        return (
            <div className="plan-title">
                {pkg.PackageName} {pkg.IsActive ? <span className="plan-current">{tLang("manageAccount.protectionPlan.current")}</span> : <></>}
            </div>
        );
    };

    const renderPrice = (pkg: IPackage) => {
        // resolved bug - 15624
        if (pkg.ShowCrossOut && pkg.Price !== 0) {
            return (
                <React.Fragment>
                    <span className="normal-text">${displayBasePriceAsCrossout(pkg)}</span>
                    {displayPackagePrice(pkg)}
                </React.Fragment>
            );
        } else if (pkg.ShowCrossOut && pkg.Price === 0) {
            return (
                <React.Fragment>
                    <div className="plan-price">
                        ${displayBasePriceAsCrossout(pkg)}
                        {displaySubscriptionTypeAbbr(pkg)}
                    </div>
                </React.Fragment>
            );
        } else if (pkg.IsUserPaid && pkg.IsActive) {
            return displayPackagePrice(pkg);
        } else if (pkg.Price !== 0) {
            return displayPackagePrice(pkg);
        }
    };

    const displayBasePriceAsCrossout = (pkg: IPackage) => {
        return (
            <React.Fragment>
                {pkg.SubcriptionType?.toLowerCase() === "monthly" && <s>{Number(pkg.BasePackagePrice).toFixed(2)}</s>}
                {pkg.SubcriptionType?.toLowerCase() === "yearly" && <s>{Number(pkg.BasePackagePriceYearly).toFixed(2)}</s>}
            </React.Fragment>
        );
    };

    const displayPackagePriceAsCrossout = (pkg: IPackage) => {
        return (
            <React.Fragment>
                {pkg.SubcriptionType?.toLowerCase() === "monthly" && <s>{Number(pkg.PackagePrice).toFixed(2)}</s>}
                {pkg.SubcriptionType?.toLowerCase() === "yearly" && <s>{Number(pkg.PackagePriceYearly).toFixed(2)}</s>}
            </React.Fragment>
        );
    };

    const displayPackagePrice = (pkg: IPackage) => {
        return (
            <React.Fragment>
                {!pkg.IsPSS ? (
                    <div className="plan-price">
                        ${Number(pkg.Price).toFixed(2)}
                        {displaySubscriptionTypeAbbr(pkg)}
                    </div>
                ) : (
                    <div className="plan-price">
                        ${displayPackagePriceAsCrossout(pkg)}
                        {displaySubscriptionTypeAbbr(pkg)}
                    </div>
                )}
            </React.Fragment>
        );
    };

    const displaySubscriptionTypeAbbr = (pkg: IPackage) => {
        return (
            <small>
                /{pkg.SubcriptionType?.toLowerCase() === "monthly" && <abbr title="Monthly">mo</abbr>}
                {pkg.SubcriptionType?.toLowerCase() === "yearly" && <abbr title="Yearly">yr</abbr>}
            </small>
        );
    };

    const renderButton = (pkg: IPackage, pkgIndex: number) => {
        const isPkgChange = pkg.Featurevalue !== protectionPlanSelector.protectionPlanData.LicenseLimit;
        if (pkg.IsActive && pkg.IsPackageCancel && pkg.ActionButtonText?.toUpperCase() === "CANCEL" && isTwoStepCancellation) {
            /* CANCEL */
            if (isPkgChange) {
                return (
                    <React.Fragment>
                        <div className="plan-cta">
                            <button
                                type="button"
                                className="btn-default btn-primary btn-min-width"
                                onClick={() => {
                                    confirmChange(pkgIndex, "BusinessProtectionPlanTwoStepCancel");
                                    setKeepPackage(true);
                                    window.addToDataLayer({ event: "Protection Plan - " + pkg.ActionButtonText?.toUpperCase() });
                                }}
                            >
                                <span className="btn-text">
                                    {tLang("manageAccount.protectionPlan.btn.keepPackage")}
                                    <span className="sr-only">{pkg.PackageName}</span>
                                </span>
                            </button>
                        </div>
                        <div className="plan-cta">
                            <button
                                type="button"
                                className="btn-default btn-link btn-min-width"
                                onClick={() => {
                                    confirmChange(pkgIndex, "BusinessProtectionPlanTwoStepCancel");
                                    window.addToDataLayer({ event: "Protection Plan - " + pkg.ActionButtonText?.toUpperCase() });
                                    setKeepPackage(false);
                                }}
                            >
                                <span className="btn-text">
                                    {tLang("manageAccount.protectionPlan.btn.cancelSubscription")}
                                    <span className="sr-only">{pkg.PackageName}</span>
                                </span>
                            </button>
                        </div>
                    </React.Fragment>
                );
            }
            return (
                <React.Fragment>
                    <div className="plan-cta">
                        <button
                            type="button"
                            className={
                                !isPkgChange
                                    ? "btn-default btn-link btn-min-width"
                                    : isPkgChange
                                        ? "btn-default btn-primary btn-min-width"
                                        : "btn-default btn-grey btn-min-width"
                            }
                            onClick={() => {
                                if (isPkgChange) {
                                    setKeepPackage(true);
                                } else {
                                    confirmChange(pkgIndex, "BusinessProtectionPlanTwoStepCancel");
                                    window.addToDataLayer({ event: "Protection Plan - " + pkg.ActionButtonText?.toUpperCase() });
                                }
                            }}
                        >
                            <span className="btn-text">
                                {!isPkgChange
                                    ? tLang("manageAccount.protectionPlan.btn.cancelSubscription")
                                    : isPkgChange
                                        ? tLang("manageAccount.protectionPlan.btn.keepPackage")
                                        : tLang("manageAccount.protectionPlan.btn.cancel")}{" "}
                                <span className="sr-only">{pkg.PackageName}</span>
                            </span>
                        </button>
                    </div>
                </React.Fragment>
            );
        }
       else if (pkg.IsActive && (pkg.IsPackageCancel || pkg.PartnerId === 428)) {
            /* CANCEL */
            if (isPkgChange) {
                return (
                    <React.Fragment>
                        <div className="plan-cta">
                            <button
                                type="button"
                                className="btn-default btn-primary btn-min-width"
                                onClick={() => {
                                    confirmChange(pkgIndex, "BusinessProtectionPlanUpgradeConfirmation");
                                    setKeepPackage(true);
                                    window.addToDataLayer({ event: "Protection Plan - " + pkg.ActionButtonText?.toUpperCase() });
                                }}
                            >
                                <span className="btn-text">
                                    {tLang("manageAccount.protectionPlan.btn.keepPackage")}
                                    <span className="sr-only">{pkg.PackageName}</span>
                                </span>
                            </button>
                        </div>
                        <div className="plan-cta">
                            <button
                                type="button"
                                className="btn-default btn-link btn-min-width"
                                onClick={() => {
                                    confirmChange(pkgIndex, "BusinessProtectionPlanUpgradeConfirmation");
                                    window.addToDataLayer({ event: "Protection Plan - " + pkg.ActionButtonText?.toUpperCase() });
                                    setKeepPackage(false);
                                }}
                            >
                                <span className="btn-text">
                                    {tLang("manageAccount.protectionPlan.btn.cancelSubscription")}
                                    <span className="sr-only">{pkg.PackageName}</span>
                                </span>
                            </button>
                        </div>
                    </React.Fragment>
                );
            }
            return (
                <React.Fragment>
                    <div className="plan-cta">
                        <button
                            type="button"
                            className={
                                !isPkgChange
                                    ? "btn-default btn-link btn-min-width"
                                    : isPkgChange
                                    ? "btn-default btn-primary btn-min-width"
                                    : "btn-default btn-grey btn-min-width"
                            }
                            onClick={() => {
                                if (isPkgChange) {
                                    setKeepPackage(true);
                                } else {
                                    confirmChange(pkgIndex, "BusinessProtectionPlanUpgradeConfirmation");
                                    window.addToDataLayer({ event: "Protection Plan - " + pkg.ActionButtonText?.toUpperCase() });
                                }
                            }}
                        >
                            <span className="btn-text">
                                {!isPkgChange
                                    ? tLang("manageAccount.protectionPlan.btn.cancelSubscription")
                                    : isPkgChange
                                    ? tLang("manageAccount.protectionPlan.btn.keepPackage")
                                    : tLang("manageAccount.protectionPlan.btn.cancel")}{" "}
                                <span className="sr-only">{pkg.PackageName}</span>
                            </span>
                        </button>
                    </div>
                </React.Fragment>
            );
        } else if (!pkg.IsActive && (pkg.IsPacakgeUpgradable || (pkg.Price != null && pkg.Price === 0 && pkg.IsPSS))) {
            /* UPGRADE | DOWNGRADE */
            return (
                <React.Fragment>
                    <div className="plan-cta">
                        <button
                            type="button"
                            className="btn-default btn-primary btn-min-width"
                            onClick={() => {
                                if (pkg.ActionButtonText?.toUpperCase() === "PURCHASE" && Number(licenseLimit) < Number(activePendingLicense)) {
                                    Notification({
                                        type: "error",
                                        title: tLang("manageAccount.protectionPlan.notification.errorTitle"),
                                        message: `You Must Cancel ${Number(activePendingLicense) - Number(licenseLimit)} ${
                                            Number(activePendingLicense) - Number(licenseLimit) > 1 ? "Employees" : "Employee"
                                        } Before Lowering License Limit.`,
                                        duration: 5,
                                    });
                                } else {
                                    setKeepPackage(false);
                                    confirmChange(pkgIndex, "BusinessProtectionPlanUpgradeConfirmation");
                                    window.addToDataLayer({ event: "Protection Plan - " + pkg.ActionButtonText?.toUpperCase() });
                                }
                            }}
                        >
                            <span className="btn-text">
                                {pkg.ActionButtonText} <span className="sr-only">to {pkg.PackageName} Plan</span>
                            </span>
                        </button>
                    </div>
                </React.Fragment>
            );
        }
    };

    const renderBilling = (pkg: IPackage) => {
        if (pkg.ShowBillingText) {
            return (
                <p>
                    {pkg.BillingText}
                    <br />
                    <br />{" "}
                </p>
            );
        }
    };

    const renderPlanLicenses = (pkg: IPackage) => {
        return (
            <div className="plan-licenses">
                <small>
                    <span className="license-count">{pkg.Featurevalue}</span>
                    {tLang("manageAccount.protectionPlan.employeeLicenses")}
                </small>
            </div>
        );
    };

    const renderSavings = (pkg: IPackage, pkgIndex: number) => {
        if (pkg.ShowSubscriptionTypeChangeText) {
            return (
                <React.Fragment>
                    {pkg.SubcriptionType?.toLowerCase() === "monthly" && pkg.PackagePriceYearly !== 0 && (
                        <div className="plan-saving">
                            {pkg.YearlySavingPrice && (
                                <span
                                    className="plan-saving-percentage"
                                    onClick={() => {
                                        confirmChangeSubscription(pkgIndex, "ProtectionPlanSubscriptionChangeDialog");
                                        window.addToDataLayer({ event: "Protection Plan - Subscription Type Change" });
                                    }}
                                >
                                    {tLang("manageAccount.protectionPlan.saveyr.text1")} {pkg.YearlySavingPrice}%{" "}
                                    {tLang("manageAccount.protectionPlan.saveyr.text2")}
                                </span>
                            )}
                            <span className="plan-price-annual">
                                ${pkg.PackagePriceYearly?.toFixed(2)}/<abbr title="Yearly">yr</abbr>
                            </span>
                        </div>
                    )}

                    {pkg.SubcriptionType?.toLowerCase() === "yearly" && pkg.PackagePrice !== 0 && (
                        <div className="plan-saving">
                            <span
                                className="plan-saving-percentage"
                                onClick={() => {
                                    confirmChangeSubscription(pkgIndex, "ProtectionPlanSubscriptionChangeDialog");
                                    window.addToDataLayer({ event: "Protection Plan - Subscription Type Change" });
                                }}
                            >
                                {tLang("manageAccount.protectionPlan.monthlySubscription")}
                            </span>
                            <span className="plan-price-annual">
                                ${pkg.PackagePrice?.toFixed(2)}/<abbr title="Monthly">mo</abbr>
                            </span>
                        </div>
                    )}
                </React.Fragment>
            );
        }
    };

    const renderProvidedBy = (pkg: IPackage) => {
        if (pkg.PartnerName) {
            return (
                <React.Fragment>
                    <p>{tLang("manageAccount.protectionPlan.providedBy")}</p>
                    <strong>{pkg.PartnerName}</strong>
                </React.Fragment>
            );
        }
    };

    const preparePackages = (licenseLimit: string) => {
        setLicenseLimit(licenseLimit);
        let pkg: IPackage[] | undefined = [];
        if (protectionPlanSelector?.protectionPlanData?.smbLicenseLimits) {
            pkg = protectionPlanSelector?.protectionPlanData?.smbLicenseLimits?.find((it: ISmbLicenseLimit) => it.key === licenseLimit)?.packageList;
        }

        setPackages(pkg);
        setIsChangingLicense(false);
    };

    const isPssPackage = packages && packages.length && packages.filter((item) => item.IsPSS).length;

    return (
        <React.Fragment>
            <div className=" row">
                <div className="col-xs-12">
                    <h1 className="title-page" id="business-protection-plan-page" tabIndex={-1}>
                        {isAvastId ? "Manage Profile" : tLang("manageAccount.title")}
                    </h1>
                </div>
            </div>

            <ManageAccountTab selectedTab="2" isAvastId={isAvastId} />

            <div className="row" id="content">
                <div className="col-xs">
                    <div className="box offset-padding">
                        <div className="box-header">
                            <div className="box-title-container">
                                <div className="box-title-icon" aria-hidden="true">
                                    <em className="las la-cube"></em>
                                </div>
                                <div className="box-title-text">
                                    <h2 className="box-title">{tLang("manageAccount.protectionPlan.tabTitle")}</h2>
                                </div>
                            </div>
                            {!protectionPlanSelector?.isLoading &&
                                protectionPlanSelector?.protectionPlanData?.packageList &&
                                protectionPlanSelector?.protectionPlanData?.packageList?.length < 1 && <NoActivePlan partnerPhoneNumber={partnerPhoneNumber} />}
                        </div>

                        {protectionPlanSelector == null || protectionPlanSelector.isLoading ? (
                            <div className="box loading"></div>
                        ) : (
                            <React.Fragment>
                                {!isDisplayNoActivePkgMsg() ? (
                                    <></>
                                ) : (
                                    <React.Fragment>
                                        <div className="msg-generic msg-small margin-top-xs">
                                            <em className="las la-info-circle"></em> {tLang("dashboard.noServiceActive.message")}{" "}
                                            {tLang("manageAccount.protectionPlan.purchaseAplan")}
                                        </div>
                                        <div className="space-divider margin-top-xs" />
                                    </React.Fragment>
                                )}

                                <div className={`box-content ${isChangingLicense ? "loading" : ""}`}>
                                    {isPssPackage ? (
                                        <></>
                                    ) : (
                                        <div className="form-row inline row no-wrap">
                                            <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                                <label htmlFor="plan-employees">{tLang("manageAccount.protectionPlan.noOfemployee")}</label>
                                            </div>
                                            <div className="form-input col-xs-12 col-sm-4 col-no-gutter">
                                                <select
                                                    className="inputbox"
                                                    id="plan-employees"
                                                    value={licenseLimit}
                                                    onChange={(e) => {
                                                        if (Number(e.target.value) < Number(activePendingLicense)) {
                                                            Notification({
                                                                type: "error",
                                                                title: tLang("manageAccount.protectionPlan.notification.errorTitle"),
                                                                message: `${tLang("manageAccount.protectionPlan.notification.cancelWarning.label1")} ${
                                                                    Number(activePendingLicense) - Number(e.target.value)
                                                                }  ${
                                                                    Number(activePendingLicense) - Number(e.target.value) > 1
                                                                        ? tLang("manageAccount.protectionPlan.notification.cancelWarning.label3")
                                                                        : tLang("manageAccount.protectionPlan.notification.cancelWarning.label2")
                                                                } ${tLang("manageAccount.protectionPlan.notification.cancelWarning.label4")}`,
                                                                duration: 5,
                                                            });
                                                        } else {
                                                            setIsChangingLicense(true);
                                                            preparePackages(e.target.value);
                                                        }
                                                    }}
                                                >
                                                    {protectionPlanSelector?.protectionPlanData?.smbLicenseLimits?.map(
                                                        (smbLicense: ISmbLicenseLimit, index: number) => (
                                                            <option key={`smb-license-key-${index}`} value={smbLicense.key}>
                                                                {smbLicense.value}
                                                            </option>
                                                        )
                                                    )}
                                                </select>
                                            </div>
                                        </div>
                                    )}

                                    <div className="padding-vertical-l"></div>

                                    <div id="plan-table-container" className="table-container scroll">
                                        <div id="table-nav-left">
                                            <button
                                                type="button"
                                                className="btn-default btn-icon-only"
                                                title="Previous Plan"
                                                id="btn-prev-plan"
                                                disabled={isFirstPlan}
                                                onClick={() => showPrevPlan()}
                                            >
                                                <span className="btn-icon">
                                                    <em className="las la-arrow-left"></em>
                                                </span>
                                                <span className="btn-text">{tLang("manageAccount.protectionPlan.btn.previousPlan")}</span>
                                            </button>
                                        </div>
                                        <div id="table-nav-right">
                                            <button
                                                type="button"
                                                className="btn-default btn-icon-only"
                                                title="Next Plan"
                                                id="btn-next-plan"
                                                onClick={() => showNextPlan()}
                                            >
                                                <span className="btn-icon">
                                                    <em className="las la-arrow-right"></em>
                                                </span>
                                                <span className="btn-text">{tLang("manageAccount.protectionPlan.btn.nextPlan")}</span>
                                            </button>
                                        </div>

                                        <table id="protection-table" className="show-plan-1">
                                            <caption className="sr-only">{tLang("manageAccount.protectionPlan.message.tableSelectedNAvailablePlans")}</caption>
                                            <thead>
                                                <React.Fragment>
                                                    <tr>
                                                        {renderSpacer()}
                                                        {renderPackageHeaderRow("title")}
                                                    </tr>
                                                    {showRow("price") && (
                                                        <tr>
                                                            {renderSpacer()}
                                                            {renderPackageHeaderRow("price")}
                                                        </tr>
                                                    )}
                                                    {showRow("plan-licenses") && (
                                                        <tr>
                                                            {renderSpacer()}
                                                            {renderPackageHeaderRow("plan-licenses")}
                                                        </tr>
                                                    )}
                                                    {showRow("cta") && (
                                                        <tr>
                                                            {renderSpacer()}
                                                            {renderPackageHeaderRow("cta")}
                                                        </tr>
                                                    )}
                                                    {showRow("billing") && (
                                                        <tr>
                                                            {renderSpacer()}
                                                            {renderPackageHeaderRow("billing")}
                                                        </tr>
                                                    )}

                                                    {showRow("savings") && (
                                                        <tr>
                                                            {renderSpacer()}
                                                            {renderPackageHeaderRow("savings")}
                                                        </tr>
                                                    )}
                                                    {showRow("providedBy") && (
                                                        <tr>
                                                            {renderSpacer()}
                                                            {renderPackageHeaderRow("providedBy")}
                                                        </tr>
                                                    )}
                                                </React.Fragment>
                                            </thead>

                                            <tbody>
                                                <tr>
                                                    <th className="row-label" scope="row">
                                                        <span className="inner-title" style={{ fontWeight: "bold" }}>
                                                            {tLang("manageAccount.protectionPlan.businessServices")}
                                                        </span>
                                                    </th>
                                                    {packages?.map((pkg: IPackage, index: number) => (
                                                        <td key={`busines-services-${pkg.PackagId}-${index}`} className="row-cell"></td>
                                                    ))}
                                                </tr>

                                                {protectionPlanSelector?.protectionPlanData?.productList?.map((product: IProduct, index: number) => (
                                                    <React.Fragment key={`business-product-${index}`}>
                                                        {!product.isChildProduct && (
                                                            <BusinessProtectionPlanRow index={index} product={product} packageList={packages} />
                                                        )}
                                                    </React.Fragment>
                                                ))}

                                                <tr>
                                                    <th className="row-label" scope="row">
                                                        <span className="inner-title" style={{ fontWeight: "bold" }}>
                                                            {tLang("manageAccount.protectionPlan.employeeServices")}
                                                        </span>
                                                    </th>
                                                    {packages?.map((pkg: IPackage, index: number) => (
                                                        <td key={`employee-services-${pkg.PackagId}-${index}`} className="row-cell"></td>
                                                    ))}
                                                </tr>

                                                {protectionPlanSelector?.protectionPlanData?.productList?.map((product: IProduct, index: number) => (
                                                    <React.Fragment key={`employee-product-${index}`}>
                                                        {product.isChildProduct && (
                                                            <BusinessProtectionPlanRow index={index} product={product} packageList={packages} />
                                                        )}
                                                    </React.Fragment>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </React.Fragment>
                        )}
                    </div>
                </div>
            </div>

            <ErrorBoundary componentName="Protection Plan Dialog Container" type="showError" replaceDefaultContent={false} errorMsg="">
                {confirmationDialog && (
                    <BusinessProtectionPlanDialogContainer
                        initialDialog={initialDialog}
                        packageIndex={packageIndex}
                        onClose={closeProtectionPlanDialog}
                        subscriptionTypeChange={subscriptionTypeChange}
                        licenseLimit={licenseLimit}
                        packages={packages}
                        keepPackage={keepPackage}
                    />
                )}
            </ErrorBoundary>
        </React.Fragment>
    );
};

export default BusinessProtectionPlan;
